import { apiSlice } from "./api/apiSlice";

const telesaleTaskSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getLeadTasks: builder.query({
            query: ({ leadId, page = 1, limit = 10 }) =>
                `/telesales/tasks/lead/${leadId}?page=${page}&limit=${limit}`,
        }),
        addtelesaleLeadTask: builder.mutation({
            query: (formdata) => ({
                url: '/telesales/tasks',
                method: 'POST',
                body: formdata,
                formData: true,
            }),
            invalidatesTags: ['Task', 'TelesalesTodo', 'TelesalesCalendar', 'TelesaleLeads'],
        }),
        getTelesalesTodoList: builder.query({
            query: (taskType = 'today') => ({
                url: `/telesales/tasks/todo?task=${taskType}`,
            }),
            transformResponse: (response) => response.tasks,
            providesTags: ['TelesalesTodo']
        }),
        getTelesalesCalendarTasks: builder.query({
            query: () => ({
                url: `/telesales/tasks/calendar/notification`,
            }),
            transformResponse: (response) => response.data.tasks,
            providesTags: ['TelesalesCalendar']
        })

    }),
});

export const { useGetLeadTasksQuery, useAddtelesaleLeadTaskMutation, useGetTelesalesTodoListQuery, useGetTelesalesCalendarTasksQuery } = telesaleTaskSlice;
